// extracted by mini-css-extract-plugin
export default {"app":"Main_app__vRYX-","hideMenu":"Main_hideMenu__l1TQl","nav":"Main_nav__+2YDt","content":"Main_content__kcczK","shadow":"Main_shadow__ZMqBv","mainInner":"Main_mainInner__eAN-3"};